
<div *ngIf="config.title == 'EarthyWorthy'">
    <div class="row">
        <ng-container *ngFor="let item of collections; let i = index">
            <div [class]="getClass(i)">
                <div class="tab-image image-1" [class.earthy-tabimage]="config.title == 'EarthyWorthy'">
                    <a>
                        <div class="background-image" (click)="categoryListing(item.title)"
                            style="background-image: url({{item.image}});">
                            <div class="earthy-feature-collections"></div>
                        </div>
                        <div class="bg-content">
                            <h2 class="titleproper" *ngIf="item.title && config.title == 'EarthyWorthy'"
                                style="font-size: 1.3rem; text-transform: uppercase; font-weight: 500;"> {{ item.title}}
                            </h2>
                            <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem">{{item.subtitle}}</p>
                        </div>
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div *ngIf="config.title == 'BBold'">
    <div class="row">
        <ng-container *ngFor="let item of collections; let i = index">
            <div [class]="getClass(i)">
                <div class="tab-image image-1" [class.earthy-tabimage]="config.title == 'BBold'">
                    <a>
                        <div class="background-image" (click)="categoryListing(item.title)"
                            style="background-image: url({{item.image}});">
                            <div class="earthy-feature-collections"></div>
                        </div>
                        <div class="bg-content">
                            <h2 class="titleproper" *ngIf="item.title && config.title == 'BBold'"
                                style="font-size: 1.3rem; text-transform: uppercase; font-weight: 500;"> {{ item.title}}
                            </h2>
                            <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem">{{item.subtitle}}</p>
                        </div>
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
</div>
<div *ngIf="config.title == 'Aiema'">
    <div class="row">
        <ng-container *ngFor="let item of collections; let i = index">
            <div [class]="getClass(i)" style="width:50%; ">
                <div class="tab-image image-1" style="background-image: linear-gradient(to right top, #009b95, #008794, #00718d, #005c82, #004771, #004771, #004771, #004771, #005c82, #00718d, #008794, #009b95); box-shadow: 0 2px 4px darkslategray;">
                    <a>
                        <div class="background-image" (click)="categoryListing1(item.title)"
                            style="background-image: url({{item.image}});background-size: 100% 110%;">
                        </div>
                       
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
    <p class="social_media_title"  style="text-align:center;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #d57c30;">
        Our Feeds from Social Media
    </p>
    <div class="social-feed-widget">
        <div class="social-feed-widget2">
            
            <div class="social-feed-widget3">
           
            <div class="facebook_title">
                <!-- <i class="fa fa-facebook"></i> -->
                Facebook
            </div>
          <div class="facebook_web">
            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Faiemaglobal%2F&tabs=timeline&width=500&height=499&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId" width="500" height="499" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>
          <div class="facebook_responsive">
            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Faiemaglobal%2F&tabs=timeline&width=300&height=400&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId" width="300" height="400" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          
          </div>
                
  
                    </div>
        <div class="social-feed-widget3">
    
    <div class="twitter_title">
        <!-- <i class="fa fa-twitter"></i> -->
        Twitter
    </div>
  <div class="twitter_web">
    <a class="twitter-timeline" data-width="500" data-height="499" data-theme="light" href="https://twitter.com/aiemaglobal?ref_src=twsrc%5Etfw">Tweets by aiemaglobal</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
    
  </div>
       
  <div class="twitter_responsive">
    <a class="twitter-timeline" data-width="300" data-height="400" href="https://twitter.com/aiemaglobal?ref_src=twsrc%5Etfw">Tweets by aiemaglobal</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> 
  </div>
    </div>
        </div>
    </div>
    
    

</div>

<div *ngIf="config.title == 'Cle'">
    <div class="row">
        <ng-container *ngFor="let item of collections; let i = index">
            <div [class]="getClass(i)" style="width:50%; ">
                <div class="tab-image image-1" style="background-image: linear-gradient(to right top, #883a01, #883a01, #883a01, #883a01, #883a01, #41413f, #41413f, #41413f, #41413f, #41413f, #41413f, #41413f); box-shadow: 0 2px 4px darkslategray;">
                    <a>
                        <div class="background-image" (click)="categoryListing1(item.title)"
                            style="background-image: url({{item.image}});background-size: 100% 110%;">
                        </div>
                       
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- <p class="social_media_title"  style="text-align:center;text-shadow: none;font-family: 'proxima-regular','sans-serif'!important; color: #d57c30;">
        Our Feeds from Social Media
    </p> -->
    <!-- <div class="social-feed-widget">
        <div class="social-feed-widget2">
            
            <div class="social-feed-widget3">
           
            <div class="facebook_title">
                Facebook
            </div>
          <div class="facebook_web">
            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Faiemaglobal%2F&tabs=timeline&width=500&height=499&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId" width="500" height="499" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          </div>
          <div class="facebook_responsive">
            <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Faiemaglobal%2F&tabs=timeline&width=300&height=400&small_header=true&adapt_container_width=true&hide_cover=true&show_facepile=true&appId" width="300" height="400" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          
          </div>
                
  
                    </div>
        <div class="social-feed-widget3">
    
    <div class="twitter_title">
        Twitter
    </div>
  <div class="twitter_web">
    <a class="twitter-timeline" data-width="500" data-height="499" data-theme="light" href="https://twitter.com/aiemaglobal?ref_src=twsrc%5Etfw">Tweets by aiemaglobal</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
    
  </div>
       
  <div class="twitter_responsive">
    <a class="twitter-timeline" data-width="300" data-height="400" href="https://twitter.com/aiemaglobal?ref_src=twsrc%5Etfw">Tweets by aiemaglobal</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"></script> 
  </div>
    </div>
        </div>
    </div> -->
    
    

</div>


<!-- <div *ngIf="config.title == 'Beaubelle'">
    <div class="row">
        <ng-container *ngFor="let item of collections; let i = index">
            <div [class]="getClass(i)">
                <div class="tab-image image-1" style="background-image: linear-gradient(to right top, #009b95, #008794, #00718d, #005c82, #004771, #004771, #004771, #004771, #005c82, #00718d, #008794, #009b95);">
                    <a>
                        <div class="background-image" (click)="brandListing(item.title)"
                            style="background-image: url({{item.image}});background-size: 100% 110%;">
                        </div>
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
</div> -->






<div *ngIf="config.title == 'Beaubelle'">
    <style> 
        .overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          
          overflow: hidden;
          width: 100%;
          height: 100%;
          -webkit-transform: scale(0);
          -ms-transform: scale(0);
          transform: scale(0);
          -webkit-transition: .3s ease;
          transition: .3s ease;
          opacity: 1;
        }
        
        .container:hover .overlay {
          -webkit-transform: scale(1.1);
          -ms-transform: scale(1.1);
          transform: scale(1.1);
        }
        
        .text {
          color: white;
          font-size: 20px;
          position: absolute;
          top: 50%;
          left: 50%;
          -webkit-transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
          text-align: center;
        }
        .ls {
    filter: blur(10px);
    -webkit-filter: blur(10px);
    -moz-filter: blur(10px);
  -o-filter: blur(10px);
  -ms-filter: blur(10px);
    position: absolute;
    max-height: 100%;
    width: 100%;
}


        </style>
    <div class="row" >
        <div class="col-sm-4">
            <div class="container" (click)="navigateTobeaubelle()"> 
              
            <img src="/assets/images/beaubelle/beaubelle.jpg" style="cursor: pointer;" class="img-thumbnail">
            
            </div>
        
    
</div>
        <div class="col-sm-4">
            <div class="container" (click)="navigateTobblabs()" > 
            <img src="/assets/images/beaubelle/b&b.jpg"  style="cursor: pointer;"      class="img-thumbnail" >
            
        </div>
        </div>
        <div class="col-sm-4">
            <div class="container" (click)="navigateTomccosmetics()">
            <img src="/assets/images/beaubelle/mccosmetics.jpg" style="cursor: pointer;" class="img-thumbnail">
            <!-- <div class="overlay">
                <img  class='ls'src="/assets/images/beaubelle/mccosmetics.jpg"  /><div class="text" style="color: black;">MC Cosmetics</div>
              </div> -->
            </div>
        </div>

      </div> 
      <div>
<div *ngIf="config.title == 'Beaubelle'" class="text-center" style="font-size: 35px !important;line-height: 1em !important;letter-spacing: 0px !important;font-family: didot !important;color: #3d4246 !important;text-transform: none !important;padding-top:40px;    position: relative;
bottom: -20px;">
              Read about your skin concern </div>
              <style>
      
                .zoom {   
                  transition: transform .2s;
                  width: 80%;
                  height: 50%;
                  margin-top:90px;
                 
                }
                .row1{
                    position: relative;
                    left: 27px!important;

                }

                @media screen and (min-width:1920px) {
                   
                .zoom {   
                  transition: transform .2s;
                  width: 80%;
                  height: 60%;
                  margin-top:90px;
                 
                }
                .row1{
                    position: relative;
                    left:93px!important;

                }

                }
                  
                    





                @media screen and (max-width: 758px) {
                    .zoom {   
                  transition: transform .2s;
                  width: 20%;
                  height: 35%;
                   cursor: pointer;
                 
                }
                    }
    
                .zoom:hover {
                  -ms-transform: scale(1.1); /* IE 9 */
                  -webkit-transform: scale(1.1); /* Safari 3-8 */
                  transform: scale(1); 
                  cursor: pointer;
                }
                .col-2{
                    max-height: 750px;
                    cursor: pointer;
                    
                }
                @media screen and (max-width: 758px) {
                    .col-2{
                    max-height: 350px;
                    cursor: pointer;
                }
                }
            
                </style>
                <div class="desktop-only" style="margin-top: -10px">
       
            
                <div  class="row">
                    <div class="col-1" ></div>
                    <div class="col-2" >
                        <div class="zoom">
                        <img      src="assets/images/beaubelle/serum.jpg" style=" height: 100%;min-width: 100px;max-width: 400px;cursor: pointer;" (click)="categoryListing('Serum')" >
                    </div>
                </div>
                    <div class="col-2">
                        <div class="zoom">
                        <img  src="assets\images\beaubelle\Peelings.jpg" style=" height: 100%;min-width: 100px;max-width: 400px;cursor: pointer;margin-left:60px;" (click)="categoryListing('Peelings')" >
                    </div>
                </div>
                    <div class="col-2">
                        <div class="zoom">
                            <img  src="assets/images/beaubelle/Aesthetical.jpg" style=" height: 100%;min-width: 100px;max-width: 400px; cursor: pointer;margin-left:120px;" (click)="categoryListing('Aesthetical Treatments For Professional')" >
                    </div>
                </div>
                    <div class="col-2">
                        <div class="zoom">
                            <img   src="assets/images/beaubelle/facewash.jpg" style=" height: 100%;min-width: 100px;max-width: 400px;cursor: pointer;margin-left:180px;" (click)="categoryListing('Facewash and Toner')" >
                    </div>
                </div>
                <div class="col-1" ></div>
                
              
            </div>
      
       
   
    <div  style="margin-top: -170px">
            
        <div class="row">
            <div class="col-1" ></div>
            <div class="col-2" >
                <div class="zoom">
                <img src="assets/images/beaubelle/Exfoliation.jpg" style=" height: 100%;min-width: 100px;max-width: 400px;cursor: pointer;" (click)="categoryListing('Exfoliation')" >
            </div>
        </div>
            <div class="col-2">
                <div class="zoom">
                <img src="assets\images\beaubelle\masks.jpg" style=" height: 100%;min-width: 100px;max-width: 400px; margin-left:60px;cursor: pointer;" (click)="categoryListing('Masks')" >
            </div>
        </div>
            <div class="col-2">
                <div class="zoom">
                    <img src="assets/images/beaubelle/Moisturizer.jpg" style=" height: 100%;min-width: 100px;max-width: 400px; margin-left:120px;cursor: pointer;" (click)="categoryListing('Moisturizer')" >
            </div>
        </div>
            <div class="col-2">
                <div class="zoom">
                    <img src="assets/images/beaubelle/sunblock.jpg" style=" height: 100%;min-width: 100px;max-width: 400px;margin-left:180px;cursor: pointer;" (click)="categoryListing('Sun Block')" >
            </div>
            <div class="col-1" ></div>
        </div>
        
       
    </div>


</div>

</div>








    <div class="mobile-only">
        <div class="row" style="    position: relative;
        top: 50px;
        padding-bottom: 150px;">
        <style>
             .zoom1 {   
                  transition: transform .2s;
                  width: 80%;
                  height: 15%;
                  
                 
                }
                    
    
                .zoom1:hover {
                  -ms-transform: scale(1.1); /* IE 9 */
                  -webkit-transform: scale(1.1); /* Safari 3-8 */
                  transform: scale(1.1); 
                }
        </style>
        <div class="col-1"></div>
        <div class="col-5" style="max-height: 350px">
            <div class="zoom1">
            <img src="assets/images/beaubelle/serum.jpg" style=" max-height: 150px;padding-bottom: 10px;" (click)="categoryListing('Serum')" >
        </div></div>
        <div class="col-5"  style="max-height: 350px">
            <div class="zoom1">
            <img src="assets\images\beaubelle\Peelings.jpg" style=" max-height: 150px;padding-bottom: 10px;" (click)="categoryListing('Peelings')" >
        </div>
    </div>
    <div class="col-1"></div>
    <div class="col-1"></div>
        <div class="col-5"  style="max-height: 350px">
            <div class="zoom1">
            <img src="assets\images\beaubelle\Aesthetical.jpg" style="max-height: 150px;padding-bottom: 10px;" (click)="categoryListing('Aesthetical Treatments For Professional')">
        </div></div>
        <div class="col-5"  style="max-height: 350px">
            <div class="zoom1">
            <img src="assets\images\beaubelle\facewash.jpg" style=" max-height: 150px;padding-bottom: 10px;" (click)="categoryListing('Facewash and Toner')">
        </div></div>
        <div class="col-1"></div>
        <div class="col-1"></div>
        <div class="col-5"  style="max-height: 350px">
            <div class="zoom1">
            <img src="assets\images\beaubelle\Exfoliation.jpg" style=" max-height: 150px;padding-bottom: 10px;" (click)="categoryListing('Exfoliation')" >
        </div></div>
        <div class="col-5"  style="max-height: 350px">
            <div class="zoom1">
            <img src="assets\images\beaubelle\masks.jpg" style=" max-height: 150px;padding-bottom: 10px;" (click)="categoryListing('Masks')" >
        </div>
    </div>
    <div class="col-1"></div>
    <div class="col-1"></div>
        <div class="col-5" style="max-height: 350px">
            <div class="zoom1">
            <img src="assets/images/beaubelle/Moisturizer.jpg" style=" max-height: 150px;padding-bottom: 10px;" (click)="categoryListing('Moisturizer')" >
        </div></div>
        <div class="col-5" style="max-height: 350px">
            <div class="zoom1">
            <img src="assets/images/beaubelle/sunblock.jpg" style=" max-height: 150px;padding-bottom: 10px;" (click)="categoryListing('Sun Block')" >
        </div></div>
        <div class="col-1"></div>

    </div>

    
</div></div> 
</div>





<!-- <div *ngIf="config.title == 'BombayHardware'">
    <div class="row">
        <ng-container *ngFor="let item of collections; let i = index">
            <div [class]="getClass(i)">
                <div class="tab-image image-1" style="background-image: linear-gradient(to right top, #AD342A, #AD342A, #AD342A, #AD342A, #AD342A, #AD342A, #AD342A, #AD342A, #AD342A, #AD342A, #AD342A, #AD342A);">
                    <a>
                        <div class="background-image" (click)="categoryListing1(item.title)"
                            style="background-image: url({{item.image}});background-size: 100% 110%;">
                        </div>
                    </a>
                </div>
            </div>
        </ng-container>
    </div>
</div> -->

<!-- <div *ngIf="config.title == 'BombayHardware'">
    <div class="row">
        <ng-container *ngFor="let item of collections; let i = index">
            <div [class]="getClass(i)">
                <div class="col-md-12" style="margin-left: 100px;">
                    <div class="tab-image image-1" [class.bombayhardware-tabimage]="config.title == 'BombayHardware'">
                        <a (click)="categoryListing(item.title)">
                            <div class="background-image"
                                style="background-image: url({{item.image}});">
                                <div class="subhcards-feature-collections"></div>
                            </div>
                            <div class="bg-content">
                                <h2 class="titleproper" *ngIf="item.title && config.title == 'BombayHardware'"
                                    style="font-size: 1.4rem; text-transform: uppercase; font-weight: 500; font-family: Lucida Handwriting;">
                                    {{ item.title}}
                                </h2>
                                <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem">{{item.subtitle}}
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>
</div>  -->

<div class="row" *ngIf="config.title == 'BombayHardware'">
    <ng-container *ngFor="let item of collections; let i = index">
            <div class="col-sm-4 col-md-2" style="width:50%">
                <div class="tab-image1 image-1">
                    <a (click)="categoryListing(item.title)" >
                    <div class="background-image1" style="background-image: url({{item.image}});"></div>
                    <div class="bg-content">
                            <h2 class="titleproper" *ngIf="item.title" style="font-size: 2.4rem;color: #AD342A;font-weight: 750"></h2>
                            <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem;color: #AD342A">{{item.subtitle}}</p>
                    </div>
                </a>
            </div>
            </div>
    </ng-container>
    </div>

    <div class="row" *ngIf="config.title == 'BombayHardware'">
        <ng-container *ngFor="let item of collections1; let i = index">
                <div class="col-sm-4 col-md-3" style="width:50%" >
                    <div class="tab-image image-1">
                        <a (click)="categoryListing(item.title)" >
                        <div class="background-image" style="background-image: url({{item.image}});"></div>
                        <div class="bg-content">
                                <h2 class="titleproper" *ngIf="item.title" style="font-size: 2.4rem;color: #AD342A;font-weight: 750"></h2>
                                <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem;color: #AD342A">{{item.subtitle}}</p>
                        </div>
                    </a>
                </div>
                </div>
        </ng-container>
        </div>

        <div class="row" *ngIf="config.title == 'BombayHardware'">
            <ng-container *ngFor="let item of collections2; let i = index">
                    <div class="col-sm-4 col-md-4 desktop-only" style="width:50%" >
                        <div class="tab-image image-1">
                            <a (click)="categoryListing(item.title)" >
                            <div class="background-image" style="background-image: url({{item.image}});"></div>
                            <div class="bg-content">
                                    <h2 class="titleproper" *ngIf="item.title" style="font-size: 2.4rem;color: #AD342A;font-weight: 750"></h2>
                                    <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem;color: #AD342A">{{item.subtitle}}</p>
                            </div>
                        </a>
                    </div>
                </div>
                <div class="mobile-only" [style]="getClass(i)" style="padding-left:5px; padding-right: 5px;">
                    <div class="tab-image image-1">
                        <a (click)="categoryListing(item.title)" >
                        <div class="background-image" style="background-image: url({{item.image}});"></div>
                        <div class="bg-content">
                                <h2 class="titleproper" *ngIf="item.title" style="font-size: 2.4rem;color: #AD342A;font-weight: 750"></h2>
                                <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem;color: #AD342A">{{item.subtitle}}</p>
                        </div>
                    </a>
                </div>
            </div>
            </ng-container>
            </div>

    

<div *ngIf="config.title == 'LuckMe'||config.title == 'Karupattiraja'">
    <div class="row" id="luckmebrands">
        <ng-container *ngFor="let item of collections; let i = index">
           
            <div [class]="getClass(i)">
                <p (click)="productsListTazTest1(item.title)" class="" *ngIf="item.title && config.title == 'Karupattiraja'" style="text-align: center;
                font-size: 22px;
                padding: 10px;
                text-transform: capitalize;
                font-weight: 600;
                cursor: pointer;">
                    {{ item.title}}
                </p>
                
                <div class="tab-image image-1" [class.luckme-tabimage]="config.title == 'LuckMe'||config.title == 'Karupattiraja'">
                    
                    <a>
                       
                        <div class="background-image" (click)="productsListTazTest1(item.title)"
                            style="background-image: url({{item.image}});">
                            <div class="luckme-feature-collections"></div>
                        </div>
                        <div class="bg-content">
                            <!-- <h2 class="titleproper" *ngIf="item.title"   style="font-size: 1.3rem; text-transform: uppercase; font-weight: 500;"> {{ item.title}} </h2> -->
                            <!-- <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem">{{item.subtitle}}</p> -->
                        </div>
                    </a>
                </div>
                
            </div>
            <div *ngIf="i==3" style="width: 100%;margin-bottom: 15px;">
                <img src="assets/images/vendor/franchise.png" style="width: 100% !important;
                height: 300px;">
            </div>
        </ng-container>
    </div>
</div>

 <!-- <div *ngIf="config.title == 'ShubhCards'">
    <div class="row" id="shubhcards">
        <ng-container *ngFor="let item of collections; let i = index">
          
            <div [class]="getClass(i)" style="width:50%">
                <div class="col-md-12 home-featured-collections">
                    <h2 class="titleproper shubhcards-featured-title" *ngIf="item.title && config.title == 'ShubhCards'">
                    {{ item.title}}
                </h2>
                    <div class="tab-image image-1" [class.shubcards-tabimage]="config.title == 'ShubhCards'">
                        <a>
                            <div class="background-image" (click)="categoryListing(item.title)"
                                style="background-image: url({{item.image}});">
                               
                            </div>
                            <div class="bg-content">
                                
                                <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem">{{item.subtitle}}
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>
</div>  -->


<div *ngIf=" config.title == 'BestGifts'|| config.title == 'Carience'">
    <div class="row">
        <ng-container *ngFor="let item of collections; let i = index">
            <div [class]="getClass(i)" style="width:50%">
                <div class="col-md-12 home-featured-collections">
                    <!-- <h2 class="titleproper"
                    style="font-size: 1.4rem; text-transform: uppercase; font-weight: bold;color:black; font-family: Lucida Handwriting;text-align: center;">
                    {{ item.title}}
                </h2> -->
                <h2 class="titleproper home-featured-collections-title">
                {{ item.title}}
            </h2>
                    <div class="tab-image image-1" [class.shubcards-tabimage1]=" config.title == 'BestGifts'|| config.title == 'Carience'">
                        <a>
                            <div class="background-image" (click)="categoryListing(item.title)"
                                style="background-image: url({{item.image}});">
                             <div class="subhcards-feature-collections"></div>
                            </div>
                            <div class="bg-content">
                                <!-- <h2 class="titleproper"
                                    style="font-size: 1.4rem; text-transform: uppercase; font-weight: bold;color:black; font-family: Lucida Handwriting;">
                                    {{ item.title}}
                                </h2> -->
                                <p class="titleproper" *ngIf="item.subtitle" style="font-size: 1.3rem">{{item.subtitle}}
                                </p>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>
</div> 
<!-- <style> 
    .overlay {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      
      /* overflow: hidden; */
      width: 100%;
      height: 100%;
      -webkit-transform: scale(0);
      -ms-transform: scale(0);
      transform: scale(0);
      -webkit-transition: .3s ease;
      transition: .3s ease;
      opacity: 1;
    }
    
    .container:hover .overlay {
      -webkit-transform: scale(1.1);
      -ms-transform: scale(1.1);
      transform: scale(1.1);
    }
    
    .text {
      color: white;
      font-size: 20px;
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      -ms-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      text-align: center;
    }
    .ls {
filter: blur(10px);
-webkit-filter: blur(10px);
-moz-filter: blur(10px);
-o-filter: blur(10px);
-ms-filter: blur(10px);
position: absolute;
max-height: 100%;
width: 100%;
}


    </style> -->

<div *ngIf="config.title == 'Deera'">
  
    <div class="featured_align" >
        <div >
            <div class="container" (click)="productsListTazTest1('Baking')" style="display: flex;justify-content: center;"> 
              
            <img src="assets/images/deera/Image-Baking.png"  class="featured_img  img-thumbnail" >
            
            </div>
        
    
</div>
        <div >
            <div class="container"  (click)="productsListTazTest1('Disposable Cutlery')" style="display: flex;justify-content: center;"> 
            <img src="assets/images/deera/Image-Disposable.png"        class=" featured_img img-thumbnail" >
            
        </div>
        </div>
        <div >
            <div class="container"  (click)="productsListTazTest1('Packaging')" style="display: flex;justify-content: center;">
            <img src="assets/images/deera/Image-Packaging.png"  class=" featured_img img-thumbnail">
            
            </div>
        </div>

      </div> 
      </div>
